/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// SVG Inline
import SVG from 'react-inlinesvg';

// Theme Material UI
import { useTheme } from '@material-ui/core/styles';

// clsx
import clsx from 'clsx';

// Styles
import useStyles from './svgIconComponent.styles';

export interface SvgIconStyles {
  size?: 'xlarge' | 'large' | 'default' | 'small' | number;
  color?: 'primary' | 'secondary' | 'white' | 'disabled' | 'default';
  bgColor?: string;
  htmlColor?: string;
  background?: string;
  style?: React.CSSProperties;
  className?: string;
}

interface SvgIconComponentProps extends SvgIconStyles {
  src: string;
}

type Props = SvgIconComponentProps;

const SvgIconComponent: React.FC<Props> = React.memo(
  ({ src, size, color, htmlColor, background, style, className }) => {
    const theme = useTheme();
    const sizes = {
      xlarge: 48,
      large: 32,
      default: 20,
      small: 16,
    };
    const colors = {
      default: 'rgba(0, 0, 0, 0.54)',
      primary: theme.palette.primary.main,
      secondary: '',
      white: '#fff',
      disabled: 'rgba(0, 0, 0, 0.26)',
    };

    const sz =
      (size && (typeof size === 'number' ? size : sizes[size])) ||
      sizes.default;
    const cl = (color && colors[color]) || htmlColor || colors.default;
    const dimensions = sz && { width: sz, height: sz };

    // padding used to complement the background(circle), thus covering the entire svg.
    const padding = Math.ceil(0.207106781 * sz) + 2;
    const classes = useStyles(cl, background, padding)();
    return (
      <SVG
        src={src}
        style={style}
        {...dimensions}
        className={clsx(classes.root, className, {
          [classes.circle]: Boolean(background),
        })}
      />
    );
  },
);

export { SvgIconComponent };
export default SvgIconComponent;
